<template>
  <v-dialog :value="isActive" persistent max-width="600" scrollable>
    <ValidationObserver v-slot="{ handleSubmit }">
      <v-card :loading="isLoading">
        <v-card-title class="pa-0 shadow-1">
          <v-img
            :src="require('@/assets/illustrations/bg_modal_card.svg')"
            cover
            position="left bottom"
            class="align-center"
            height="65px"
          >
            <v-card-title class="font-weight-medium primary--text">
              {{ isEditMode ? "Actualizar" : "Crear" }} formulario
            </v-card-title>
          </v-img>
        </v-card-title>

        <vuescroll
          :ops="{
            bar: { background: '#bacfcec0', keepShow: true }
          }"
        >
          <v-card-text style="max-height: 450px">
            <v-row>
              <!-- Título -->
              <v-col cols="12" class="pb-0">
                <ValidationProvider
                  name="título"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    v-model="payload.title"
                    :error-messages="errors"
                    label="Título"
                    rounded
                    filled
                    class="rounded-lg"
                  ></v-text-field>
                </ValidationProvider>
              </v-col>

              <!-- Mensaje inicial -->
              <v-col cols="12" class="pb-0">
                <ValidationProvider
                  name="mensaje inicial"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-textarea
                    v-model="payload.initial_message"
                    :error-messages="errors"
                    label="Mensaje inicial"
                    rounded
                    filled
                    class="rounded-lg"
                  ></v-textarea>
                </ValidationProvider>
              </v-col>

              <!-- Mensaje de cierre -->
              <v-col cols="12" class="pb-0">
                <ValidationProvider
                  name="mensaje de cierre"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-textarea
                    v-model="payload.end_message"
                    :error-messages="errors"
                    label="Mensaje de cierre"
                    rounded
                    filled
                    class="rounded-lg"
                  ></v-textarea>
                </ValidationProvider>
              </v-col>

              <v-col cols="12" class="py-0">
                <ValidationProvider
                  name="whatsapp"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-select
                    :disabled="isLoading"
                    v-model="payload.whatsapp_id"
                    :items="whatsappList"
                    :error-messages="errors"
                    item-text="name"
                    item-value="id"
                    prepend-inner-icon="mdi-account"
                    label="WhatsApp"
                    filled
                    rounded
                    class="rounded-small"
                  >
                    <template v-slot:item="{ item, on, attrs }">
                      <v-list-item
                        two-line
                        selectable
                        v-on="on"
                        v-bind="attrs"
                        class="pl-3"
                      >
                        <template>
                          <v-list-item-content>
                            <v-list-item-title>
                              {{ item.name + " " }}
                            </v-list-item-title>

                            <v-list-item-subtitle>
                              {{ item.number }}
                            </v-list-item-subtitle>
                          </v-list-item-content>
                        </template>
                      </v-list-item>
                    </template>
                  </v-select>
                </ValidationProvider>
              </v-col>
            </v-row>
          </v-card-text>
        </vuescroll>
        <v-card-actions>
          <v-btn
            @click="closeDialog()"
            class="px-8"
            color="error"
            rounded
            large
            text
          >
            Cerrar
          </v-btn>
          <v-spacer></v-spacer>

          <v-btn
            @click="handleSubmit(submitForm)"
            :disabled="isLoading"
            class="px-8"
            color="success"
            rounded
            large
          >
            {{ isEditMode ? "Actualizar" : "Crear" }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </ValidationObserver>
  </v-dialog>
</template>

<script>
import vuescroll from "vuescroll";
import { PbxHttpClient } from "@/services/httpclient";
import axios from "axios";

export default {
  components: {
    vuescroll
  },

  props: {
    isActive: {
      type: Boolean
    },
    isEditMode: {
      type: Boolean,
      default: false
    },
    dataToEdit: {
      type: Object,
      default: {}
    }
  },

  data() {
    return {
      isLoading: false,
      queueList: [],
      clientList: [],
      whatsappList: [],
      payload: {
        name: "",
        menu_message: "",
        return_message: "",
        initial_message: "",
        closing_time_sg: null,
        goodbye_message: "",
        closing_queue: null,
        whatsapp_id: null,
        use: null
      }
    };
  },

  created() {
    this.getSelectsInfo();
    this.payload = { ...this.dataToEdit };
  },

  methods: {
    resetform() {
      this.payload.name = "";
      this.payload.menu_message = "";
      this.payload.return_message = "";
      this.payload.initial_message = "";
      this.payload.closing_time_sg = null;
      this.payload.goodbye_message = "";
      this.payload.closing_queue = null;
      this.payload.whatsapp_id = null;
      this.payload.use = null;
    },

    closeDialog(data = false) {
      this.$emit("close:dialog", data);
    },

    async getSelectsInfo() {
      // this.isLoading = true;

      // const accessToken = localStorage.getItem("token");

      let endpoints = [
        // `/admin/contacts`,
        `/whatsapps/config/index_select`,
        "/clients/index_whatsapp",
      ];

      await axios
        .all(
          endpoints.map((endpoint) =>PbxHttpClient.get(endpoint)))
        .then((res) => {
          // this.contactList = res[0].data.data;
          this.whatsappList = res[0].data;
          if (this.whatsappList.length > 0) {
            this.payload.whatsapp_id = this.whatsappList[0].id;
          }
          // console.log("Listo", res);

          this.queueList = res[1].data.data;
        })
        .catch((error) => {
          console.error(error);
          this.$snotify.error("Hubo un error en la consulta.", "Error");
        });
      // .finally(() => {
      //   this.isLoading = false;
      // });
    },

    async submitForm() {
      this.isLoading = true;

      // const accessToken = localStorage.getItem("token");

      // const { id, ...payload } = this.payload;

      try {
        const { id, ...payload } = this.payload;
        const { data } = this.isEditMode
          ? await PbxHttpClient.put(`/survey_chats/${id}`, payload)
          : await PbxHttpClient.post("/survey_chats", payload);
        this.closeDialog(data);

        this.$snotify.success(
          `Formulario ${this.isEditMode ? "actualizado" : "creado"} con éxito.`,
          "¡Hecho!"
        );
      } catch (err) {
        this.$snotify.error("No se pudo realizar la acción.", "¡Error!");
      }

      this.isLoading = false;
    }
  }
};
</script>
